import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import PanesHeader from 'modules/core/components/PanesHeader'
import i18n from 'modules/core/lib/i18n'

import { InputItem } from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/InputItem'
import type { FilesStore } from 'modules/documents/components/Documents/store'

interface CustomFieldsProps {
  customFieldsForms: Form[]
  store?: FilesStore
  title?: string
  description?: string
  currency?: string
}

const FolderCustomFields = ({
  customFieldsForms,
  store,
  title,
  description,
  currency,
}: CustomFieldsProps) => {
  if (store && store.files.length === 0) return null

  const renderCustomFieldList = (forms: Form[]) => {
    return (
      <div>
        {forms.map((form: Form, key: number) => (
          <FormRow key={key}>
            <InputItem form={form} currency={currency} />
          </FormRow>
        ))}
      </div>
    )
  }

  if (customFieldsForms.length === 0) {
    return null
  }

  return (
    <>
      <PanesHeader
        illustration="input-field"
        title={title || i18n.t('settings.custom_fields.title')}
        description={description || i18n.t('settings.custom_fields.description')}
      />
      {renderCustomFieldList(customFieldsForms)}
    </>
  )
}

export default observer(FolderCustomFields)
